import { render } from "./po-form.vue?vue&type=template&id=e9b4d190&scoped=true"
import script from "./po-form.vue?vue&type=script&lang=js"
export * from "./po-form.vue?vue&type=script&lang=js"

import "./po-form.vue?vue&type=style&index=0&id=e9b4d190&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b4d190"]])

export default __exports__